module.exports = __webpack_public_path__ + "img/suqian.7484ade1.png";